// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brand-landing {
  --bl-blue-q: #1b3380;
  --bl-blue-p: #1b87e6;
  --bl-blue-soft: #eef3fb;
  --bl-border: rgba(27, 51, 128, 0.12);
  --bl-muted: rgba(27, 51, 128, 0.72);
  --bl-max: min(1280px, calc(100% - 56px));
  font-family: 'Fira Sans', Arial, sans-serif;
  color: var(--bl-blue-q);
  background: #fff;
  line-height: 1.55;
  overflow-x: hidden;
}

/* AOS-style fade-up (matches questionpro.com CX marketing pages) */
.brand-landing-reveal {
  opacity: 0;
  transform: translate3d(0, 100px, 0);
  transition-property: opacity, transform;
  transition-duration: 0.8s;
  transition-timing-function: ease;
  will-change: opacity, transform;
}

.brand-landing-reveal.is-visible {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

@media (prefers-reduced-motion: reduce) {
  .brand-landing-reveal {
    opacity: 1;
    transform: none;
    transition: none;
  }
}

.brand-landing *,
.brand-landing *::before,
.brand-landing *::after {
  box-sizing: border-box;
}

.brand-landing a {
  color: inherit;
  text-decoration: none;
}

.brand-landing__header {
  position: sticky;
  top: 0;
  z-index: 40;
  border-bottom: 1px solid var(--bl-border);
  background: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(10px);
}

.brand-landing__header-inner,
.brand-landing__wrap {
  width: var(--bl-max);
  margin: 0 auto;
}

.brand-landing__header-inner {
  min-height: 74px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  padding: 12px 0;
}

.brand-landing__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  font-weight: 600;
  font-size: 15px;
}

.brand-landing__brand img {
  height: 34px;
  width: auto;
  max-width: 170px;
  object-fit: contain;
}

.brand-landing__brand-divider {
  width: 1px;
  height: 22px;
  background: rgba(27, 51, 128, 0.2);
}

.brand-landing__nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 14px 28px;
}

.brand-landing__nav a {
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
}

.brand-landing__nav a:hover {
  color: var(--bl-blue-p);
}

.brand-landing__btn,
.brand-landing a.brand-landing__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1.5px solid var(--bl-blue-q);
  background: var(--bl-blue-q);
  color: rgb(var(--wu-gray-10));
  font-weight: 600;
  font-size: 15.5px;
  line-height: 1.6;
  padding: 13px 26px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;
}

.brand-landing__btn--nav,
.brand-landing a.brand-landing__btn--nav {
  font-size: 15.5px;
  padding: 13px 26px;
  border-radius: 8px;
}

.brand-landing__btn--hero,
.brand-landing a.brand-landing__btn--hero {
  font-size: 17px;
  line-height: 1.6;
  padding: 16px 36px;
  border-radius: 8px;
  box-shadow: 0 12px 24px rgba(27, 51, 128, 0.14);
}

.brand-landing__btn:hover,
.brand-landing a.brand-landing__btn:hover {
  background: var(--bl-blue-p);
  border-color: var(--bl-blue-p);
  color: rgb(var(--wu-gray-10));
}

.brand-landing__btn--ghost {
  background: transparent;
  color: var(--bl-blue-q);
  box-shadow: none;
}

.brand-landing__btn--ghost:hover {
  background: var(--bl-blue-soft);
  color: var(--bl-blue-q);
}

.brand-landing__btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.brand-landing__hero {
  padding: clamp(60px, 7vw, 96px) 0 clamp(40px, 6vw, 64px);
  text-align: center;
}

.brand-landing__eyebrow {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--bl-blue-p);
  margin: 0 0 14px;
}

.brand-landing__hero h1 {
  margin: 0 auto 18px;
  max-width: 14ch;
  font-size: clamp(42px, 6.5vw, 82px);
  line-height: 1.01;
  font-weight: 700;
  letter-spacing: -0.042em;
}

.brand-landing__hero-body {
  margin: 0 auto;
  max-width: 688px;
  font-size: 20px;
  line-height: 32px;
  font-weight: 500;
  color: var(--bl-muted);
}

.brand-landing__section-body {
  margin: 0 auto;
  max-width: 62ch;
  font-size: 17px;
  color: var(--bl-muted);
}

.brand-landing__cta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 20px;
  justify-content: center;
  align-items: center;
  margin-top: 32px;
}

.brand-landing__link-btn {
  background: none;
  border: none;
  color: var(--bl-blue-q);
  font: inherit;
  font-weight: 600;
  font-size: 17px;
  line-height: 1.6;
  cursor: pointer;
  padding: 16px 8px;
}

.brand-landing__link-btn:hover {
  color: var(--bl-blue-p);
}

.brand-landing__hint {
  margin: 20px 0 0;
  font-size: 14.5px;
  line-height: 23px;
  font-weight: 600;
  color: var(--bl-muted);
}

.brand-landing__section {
  padding: clamp(56px, 8vw, 100px) 0;
}

.brand-landing__section--soft {
  background: rgba(27, 135, 230, 0.045);
  border-top: 1px solid var(--bl-border);
  border-bottom: 1px solid var(--bl-border);
}

.brand-landing__section--dark {
  background: var(--bl-blue-q);
  color: #fff;
}

.brand-landing__section--dark .brand-landing__eyebrow {
  color: #8fc8f4;
}

.brand-landing__section--dark .brand-landing__section-body {
  color: rgba(255, 255, 255, 0.78);
}

.brand-landing__section-head {
  text-align: center;
  margin-bottom: clamp(28px, 4vw, 44px);
}

.brand-landing__section-head h2 {
  margin: 0 0 12px;
  font-size: clamp(28px, 4vw, 42px);
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.brand-landing__workflow-rows {
  display: grid;
  gap: clamp(40px, 6vw, 72px);
}

.brand-landing__workflow-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);
  gap: clamp(24px, 4vw, 48px);
  align-items: center;
}

.brand-landing__workflow-row--reverse .brand-landing__workflow-copy {
  order: 2;
}

.brand-landing__workflow-row--reverse .brand-landing__workflow-visual {
  order: 1;
}

.brand-landing__workflow-kicker {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.brand-landing__step-n {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 999px;
  background: var(--bl-blue-soft);
  color: var(--bl-blue-q);
  font-size: 13px;
  font-weight: 700;
  flex: none;
}

.brand-landing__step-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--bl-blue-p);
  margin: 0;
}

.brand-landing__workflow-copy h3 {
  margin: 0 0 12px;
  font-size: clamp(26px, 3.2vw, 34px);
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.brand-landing__workflow-copy > p {
  margin: 0;
  font-size: 16px;
  color: var(--bl-muted);
  max-width: 38ch;
}

.brand-landing__workflow-tip {
  margin: 16px 0 0 !important;
  font-size: 15px !important;
  font-weight: 700;
  color: var(--bl-blue-q) !important;
}

.brand-landing__workflow-visual {
  min-width: 0;
}

.brand-landing-mock {
  border: 1px solid var(--bl-border);
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(27, 51, 128, 0.08);
}

.brand-landing-mock__chrome {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 12px 14px;
  background: var(--bl-blue-soft);
  border-bottom: 1px solid var(--bl-border);
}

.brand-landing-mock__dots {
  display: inline-flex;
  gap: 5px;
  width: 56px;
}

.brand-landing-mock__dots i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(27, 51, 128, 0.22);
}

.brand-landing-mock__chrome-title {
  flex: 1 1;
  text-align: center;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--bl-muted);
}

.brand-landing-mock__chrome-badge {
  width: 56px;
  text-align: right;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--bl-blue-p);
}

.brand-landing-mock__body {
  padding: 18px;
}

.brand-landing-mock__label {
  margin: 0 0 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--bl-muted);
}

.brand-landing-mock__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 14px;
  border: 1px solid var(--bl-border);
  border-radius: 12px;
  margin-bottom: 10px;
}

.brand-landing-mock__field span {
  font-size: 12px;
  color: var(--bl-muted);
}

.brand-landing-mock__field strong {
  font-size: 14.5px;
  font-weight: 600;
}

.brand-landing-mock__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 8px;
}

.brand-landing-mock__list li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid var(--bl-border);
  border-radius: 12px;
  font-size: 14px;
}

.brand-landing-mock__list li.is-done {
  border-color: rgba(27, 135, 230, 0.35);
  background: rgba(27, 135, 230, 0.04);
}

.brand-landing-mock__list em {
  font-style: normal;
  font-size: 12.5px;
  font-weight: 700;
  color: var(--bl-blue-p);
}

.brand-landing-mock__list em.is-bad {
  color: #a50000;
}

.brand-landing-mock__engines {
  display: grid;
  gap: 8px;
}

.brand-landing-mock__engines > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border: 1px solid var(--bl-border);
  border-radius: 12px;
  font-size: 14px;
}

.brand-landing-mock__engines span {
  color: var(--bl-muted);
  font-size: 13px;
}

.brand-landing-mock__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 14px;
  font-size: 12.5px;
  color: var(--bl-muted);
}

.brand-landing-mock__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 14px;
  border-radius: 999px;
  background: var(--bl-blue-soft);
  color: var(--bl-blue-q);
  font-size: 13px;
  font-weight: 700;
}

.brand-landing-mock__btn--soft {
  background: rgba(27, 135, 230, 0.12);
  color: var(--bl-blue-p);
}

.brand-landing__audience h3 {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 700;
}

.brand-landing__audience p {
  margin: 0;
  font-size: 14.5px;
  color: var(--bl-muted);
}

@media (max-width: 860px) {
  .brand-landing__workflow-row,
  .brand-landing__workflow-row--reverse {
    grid-template-columns: 1fr;
  }

  .brand-landing__workflow-row--reverse .brand-landing__workflow-copy,
  .brand-landing__workflow-row--reverse .brand-landing__workflow-visual {
    order: initial;
  }

  .brand-landing__workflow-copy > p {
    max-width: none;
  }
}

.brand-landing__audiences {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
}

.brand-landing__audience {
  border: 1px solid var(--bl-border);
  border-radius: 14px;
  padding: 22px;
  background: #fff;
}

.brand-landing__faq-list {
  max-width: 720px;
  margin: 0 auto;
  display: grid;
  gap: 10px;
}

.brand-landing__faq-list details {
  border: 1px solid var(--bl-border);
  border-radius: 12px;
  padding: 14px 16px;
  background: #fff;
}

.brand-landing__faq-list summary {
  cursor: pointer;
  font-weight: 700;
  font-size: 15.5px;
  list-style: none;
}

.brand-landing__faq-list summary::-webkit-details-marker {
  display: none;
}

.brand-landing__faq-list details p {
  margin: 10px 0 0;
  font-size: 14.5px;
  color: var(--bl-muted);
}

.brand-landing__signup {
  text-align: center;
}

.brand-landing__signup h2 {
  margin: 0 0 12px;
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 800;
}

.brand-landing__footer {
  border-top: 1px solid var(--bl-border);
  padding: 22px 0;
  font-size: 13px;
  color: var(--bl-muted);
  text-align: center;
}

/* Demo */
.brand-landing-demo {
  border: 1px solid var(--bl-border);
  border-radius: 16px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 18px 50px rgba(27, 51, 128, 0.08);
}

.brand-landing-demo__tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--bl-border);
  background: var(--bl-blue-soft);
}

.brand-landing-demo__tab {
  border: 1px solid transparent;
  background: transparent;
  border-radius: 999px;
  padding: 8px 14px;
  font: inherit;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--bl-blue-q);
  cursor: pointer;
}

.brand-landing-demo__tab.is-active {
  background: #fff;
  border-color: var(--bl-border);
  color: var(--bl-blue-p);
}

.brand-landing-demo__body {
  padding: 20px;
}

.brand-landing-demo__title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 16px;
}

.brand-landing-demo__title-row h3 {
  margin: 0;
  font-size: 18px;
}

.brand-landing-demo__badge {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  background: rgba(27, 135, 230, 0.12);
  color: var(--bl-blue-p);
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
}

.brand-landing-demo__sov {
  display: grid;
  gap: 10px;
  margin-bottom: 18px;
}

.brand-landing-demo__sov-row {
  display: grid;
  grid-template-columns: 140px 1fr 42px;
  gap: 10px;
  align-items: center;
  font-size: 13px;
}

.brand-landing-demo__bar {
  height: 10px;
  border-radius: 999px;
  background: #e8eef7;
  overflow: hidden;
}

.brand-landing-demo__bar > span {
  display: block;
  height: 100%;
  border-radius: inherit;
}

.brand-landing-demo__ranks {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 10px;
}

.brand-landing-demo__rank {
  border: 1px solid var(--bl-border);
  border-radius: 12px;
  padding: 12px;
}

.brand-landing-demo__rank strong {
  display: block;
  font-size: 22px;
  margin-top: 4px;
}

.brand-landing-demo__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13.5px;
}

.brand-landing-demo__table th,
.brand-landing-demo__table td {
  text-align: left;
  padding: 10px 8px;
  border-bottom: 1px solid var(--bl-border);
  vertical-align: top;
}

.brand-landing-demo__table th {
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--bl-muted);
}

.brand-landing-demo__pill {
  display: inline-flex;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 700;
}

.brand-landing-demo__pill--true {
  background: #dff2bf;
  color: #227700;
}

.brand-landing-demo__pill--false {
  background: #ffbaba;
  color: #a50000;
}

.brand-landing-demo__pill--stale {
  background: #feefb3;
  color: #9f6000;
}

.brand-landing-demo__pill--unverifiable {
  background: #eee;
  color: #555;
}

.brand-landing-demo__drift-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px;
  margin-bottom: 16px;
}

.brand-landing-demo__stat {
  border: 1px solid var(--bl-border);
  border-radius: 12px;
  padding: 12px;
}

.brand-landing-demo__stat strong {
  display: block;
  font-size: 22px;
  margin-top: 4px;
}

.brand-landing-demo__note {
  margin: 0 0 14px;
  font-size: 13.5px;
  color: var(--bl-muted);
}

/* Form */
.brand-landing-form {
  max-width: 440px;
  margin: 28px auto 0;
  text-align: left;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 16px;
  padding: 22px;
}

.brand-landing-form label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
}

.brand-landing-form input {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.95);
  color: var(--bl-blue-q);
  border-radius: 10px;
  padding: 11px 12px;
  font: inherit;
  font-size: 15px;
  margin-bottom: 14px;
}

.brand-landing-form__hint {
  margin: -8px 0 14px;
  font-size: 12.5px;
  color: rgba(255, 255, 255, 0.72);
}

.brand-landing-form__summary {
  margin: 0 0 16px;
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.82);
  word-break: break-word;
}

.brand-landing-form__back {
  display: block;
  width: 100%;
  margin-top: 12px;
  padding: 8px 0;
  border: none;
  background: transparent;
  color: rgba(255, 255, 255, 0.78);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  text-align: center;
}

.brand-landing-form__back:hover {
  color: #fff;
}

.brand-landing-form__error {
  margin: 0 0 12px;
  font-size: 13.5px;
  color: #ffbaba;
}

.brand-landing-form .brand-landing__btn {
  width: 100%;
  margin-top: 4px;
  background: rgb(var(--wu-blue-p));
  border-color: rgb(var(--wu-blue-p));
  color: rgb(var(--wu-gray-10));
}

.brand-landing-form .brand-landing__btn:hover {
  background: rgb(var(--wu-blue-pHover, 84 165 236));
  border-color: rgb(var(--wu-blue-pHover, 84 165 236));
  color: rgb(var(--wu-gray-10));
}

.brand-landing-form__success {
  text-align: left;
}

.brand-landing-form__success h3 {
  margin: 0 0 8px;
  font-size: 22px;
}

.brand-landing-form__success p {
  margin: 0 0 16px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 14.5px;
}

.brand-landing-form__password-box {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  background: rgba(0, 0, 0, 0.18);
  border-radius: 12px;
  padding: 12px 14px;
}

.brand-landing-form__password-box code {
  flex: 1 1;
  min-width: 160px;
  font-size: 15px;
  word-break: break-all;
}

@media (max-width: 640px) {
  .brand-landing-demo__sov-row {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/brand-landing/BrandLandingPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,uBAAuB;EACvB,oCAAoC;EACpC,mCAAmC;EACnC,wCAAwC;EACxC,2CAA2C;EAC3C,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,UAAU;EACV,mCAAmC;EACnC,uCAAuC;EACvC,yBAAyB;EACzB,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,yCAAyC;EACzC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iFAAiF;AACnF;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;;EAEE,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;EACxD,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,uDAAuD;EACvD,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;EAClB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,qCAAqC;EACrC,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,kDAAkD;EAClD,oDAAoD;EACpD,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF","sourcesContent":[".brand-landing {\n  --bl-blue-q: #1b3380;\n  --bl-blue-p: #1b87e6;\n  --bl-blue-soft: #eef3fb;\n  --bl-border: rgba(27, 51, 128, 0.12);\n  --bl-muted: rgba(27, 51, 128, 0.72);\n  --bl-max: min(1280px, calc(100% - 56px));\n  font-family: 'Fira Sans', Arial, sans-serif;\n  color: var(--bl-blue-q);\n  background: #fff;\n  line-height: 1.55;\n  overflow-x: hidden;\n}\n\n/* AOS-style fade-up (matches questionpro.com CX marketing pages) */\n.brand-landing-reveal {\n  opacity: 0;\n  transform: translate3d(0, 100px, 0);\n  transition-property: opacity, transform;\n  transition-duration: 0.8s;\n  transition-timing-function: ease;\n  will-change: opacity, transform;\n}\n\n.brand-landing-reveal.is-visible {\n  opacity: 1;\n  transform: translate3d(0, 0, 0);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .brand-landing-reveal {\n    opacity: 1;\n    transform: none;\n    transition: none;\n  }\n}\n\n.brand-landing *,\n.brand-landing *::before,\n.brand-landing *::after {\n  box-sizing: border-box;\n}\n\n.brand-landing a {\n  color: inherit;\n  text-decoration: none;\n}\n\n.brand-landing__header {\n  position: sticky;\n  top: 0;\n  z-index: 40;\n  border-bottom: 1px solid var(--bl-border);\n  background: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(10px);\n}\n\n.brand-landing__header-inner,\n.brand-landing__wrap {\n  width: var(--bl-max);\n  margin: 0 auto;\n}\n\n.brand-landing__header-inner {\n  min-height: 74px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  flex-wrap: wrap;\n  padding: 12px 0;\n}\n\n.brand-landing__brand {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  font-weight: 600;\n  font-size: 15px;\n}\n\n.brand-landing__brand img {\n  height: 34px;\n  width: auto;\n  max-width: 170px;\n  object-fit: contain;\n}\n\n.brand-landing__brand-divider {\n  width: 1px;\n  height: 22px;\n  background: rgba(27, 51, 128, 0.2);\n}\n\n.brand-landing__nav {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 14px 28px;\n}\n\n.brand-landing__nav a {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 24px;\n}\n\n.brand-landing__nav a:hover {\n  color: var(--bl-blue-p);\n}\n\n.brand-landing__btn,\n.brand-landing a.brand-landing__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  border: 1.5px solid var(--bl-blue-q);\n  background: var(--bl-blue-q);\n  color: rgb(var(--wu-gray-10));\n  font-weight: 600;\n  font-size: 15.5px;\n  line-height: 1.6;\n  padding: 13px 26px;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.brand-landing__btn--nav,\n.brand-landing a.brand-landing__btn--nav {\n  font-size: 15.5px;\n  padding: 13px 26px;\n  border-radius: 8px;\n}\n\n.brand-landing__btn--hero,\n.brand-landing a.brand-landing__btn--hero {\n  font-size: 17px;\n  line-height: 1.6;\n  padding: 16px 36px;\n  border-radius: 8px;\n  box-shadow: 0 12px 24px rgba(27, 51, 128, 0.14);\n}\n\n.brand-landing__btn:hover,\n.brand-landing a.brand-landing__btn:hover {\n  background: var(--bl-blue-p);\n  border-color: var(--bl-blue-p);\n  color: rgb(var(--wu-gray-10));\n}\n\n.brand-landing__btn--ghost {\n  background: transparent;\n  color: var(--bl-blue-q);\n  box-shadow: none;\n}\n\n.brand-landing__btn--ghost:hover {\n  background: var(--bl-blue-soft);\n  color: var(--bl-blue-q);\n}\n\n.brand-landing__btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.brand-landing__hero {\n  padding: clamp(60px, 7vw, 96px) 0 clamp(40px, 6vw, 64px);\n  text-align: center;\n}\n\n.brand-landing__eyebrow {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--bl-blue-p);\n  margin: 0 0 14px;\n}\n\n.brand-landing__hero h1 {\n  margin: 0 auto 18px;\n  max-width: 14ch;\n  font-size: clamp(42px, 6.5vw, 82px);\n  line-height: 1.01;\n  font-weight: 700;\n  letter-spacing: -0.042em;\n}\n\n.brand-landing__hero-body {\n  margin: 0 auto;\n  max-width: 688px;\n  font-size: 20px;\n  line-height: 32px;\n  font-weight: 500;\n  color: var(--bl-muted);\n}\n\n.brand-landing__section-body {\n  margin: 0 auto;\n  max-width: 62ch;\n  font-size: 17px;\n  color: var(--bl-muted);\n}\n\n.brand-landing__cta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px 20px;\n  justify-content: center;\n  align-items: center;\n  margin-top: 32px;\n}\n\n.brand-landing__link-btn {\n  background: none;\n  border: none;\n  color: var(--bl-blue-q);\n  font: inherit;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 1.6;\n  cursor: pointer;\n  padding: 16px 8px;\n}\n\n.brand-landing__link-btn:hover {\n  color: var(--bl-blue-p);\n}\n\n.brand-landing__hint {\n  margin: 20px 0 0;\n  font-size: 14.5px;\n  line-height: 23px;\n  font-weight: 600;\n  color: var(--bl-muted);\n}\n\n.brand-landing__section {\n  padding: clamp(56px, 8vw, 100px) 0;\n}\n\n.brand-landing__section--soft {\n  background: rgba(27, 135, 230, 0.045);\n  border-top: 1px solid var(--bl-border);\n  border-bottom: 1px solid var(--bl-border);\n}\n\n.brand-landing__section--dark {\n  background: var(--bl-blue-q);\n  color: #fff;\n}\n\n.brand-landing__section--dark .brand-landing__eyebrow {\n  color: #8fc8f4;\n}\n\n.brand-landing__section--dark .brand-landing__section-body {\n  color: rgba(255, 255, 255, 0.78);\n}\n\n.brand-landing__section-head {\n  text-align: center;\n  margin-bottom: clamp(28px, 4vw, 44px);\n}\n\n.brand-landing__section-head h2 {\n  margin: 0 0 12px;\n  font-size: clamp(28px, 4vw, 42px);\n  line-height: 1.15;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.brand-landing__workflow-rows {\n  display: grid;\n  gap: clamp(40px, 6vw, 72px);\n}\n\n.brand-landing__workflow-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 1.05fr);\n  gap: clamp(24px, 4vw, 48px);\n  align-items: center;\n}\n\n.brand-landing__workflow-row--reverse .brand-landing__workflow-copy {\n  order: 2;\n}\n\n.brand-landing__workflow-row--reverse .brand-landing__workflow-visual {\n  order: 1;\n}\n\n.brand-landing__workflow-kicker {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.brand-landing__step-n {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 999px;\n  background: var(--bl-blue-soft);\n  color: var(--bl-blue-q);\n  font-size: 13px;\n  font-weight: 700;\n  flex: none;\n}\n\n.brand-landing__step-label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--bl-blue-p);\n  margin: 0;\n}\n\n.brand-landing__workflow-copy h3 {\n  margin: 0 0 12px;\n  font-size: clamp(26px, 3.2vw, 34px);\n  line-height: 1.15;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.brand-landing__workflow-copy > p {\n  margin: 0;\n  font-size: 16px;\n  color: var(--bl-muted);\n  max-width: 38ch;\n}\n\n.brand-landing__workflow-tip {\n  margin: 16px 0 0 !important;\n  font-size: 15px !important;\n  font-weight: 700;\n  color: var(--bl-blue-q) !important;\n}\n\n.brand-landing__workflow-visual {\n  min-width: 0;\n}\n\n.brand-landing-mock {\n  border: 1px solid var(--bl-border);\n  border-radius: 16px;\n  background: #fff;\n  overflow: hidden;\n  box-shadow: 0 18px 50px rgba(27, 51, 128, 0.08);\n}\n\n.brand-landing-mock__chrome {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  padding: 12px 14px;\n  background: var(--bl-blue-soft);\n  border-bottom: 1px solid var(--bl-border);\n}\n\n.brand-landing-mock__dots {\n  display: inline-flex;\n  gap: 5px;\n  width: 56px;\n}\n\n.brand-landing-mock__dots i {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgba(27, 51, 128, 0.22);\n}\n\n.brand-landing-mock__chrome-title {\n  flex: 1;\n  text-align: center;\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--bl-muted);\n}\n\n.brand-landing-mock__chrome-badge {\n  width: 56px;\n  text-align: right;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--bl-blue-p);\n}\n\n.brand-landing-mock__body {\n  padding: 18px;\n}\n\n.brand-landing-mock__label {\n  margin: 0 0 12px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--bl-muted);\n}\n\n.brand-landing-mock__field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 12px 14px;\n  border: 1px solid var(--bl-border);\n  border-radius: 12px;\n  margin-bottom: 10px;\n}\n\n.brand-landing-mock__field span {\n  font-size: 12px;\n  color: var(--bl-muted);\n}\n\n.brand-landing-mock__field strong {\n  font-size: 14.5px;\n  font-weight: 600;\n}\n\n.brand-landing-mock__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 8px;\n}\n\n.brand-landing-mock__list li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid var(--bl-border);\n  border-radius: 12px;\n  font-size: 14px;\n}\n\n.brand-landing-mock__list li.is-done {\n  border-color: rgba(27, 135, 230, 0.35);\n  background: rgba(27, 135, 230, 0.04);\n}\n\n.brand-landing-mock__list em {\n  font-style: normal;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--bl-blue-p);\n}\n\n.brand-landing-mock__list em.is-bad {\n  color: #a50000;\n}\n\n.brand-landing-mock__engines {\n  display: grid;\n  gap: 8px;\n}\n\n.brand-landing-mock__engines > div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 14px;\n  border: 1px solid var(--bl-border);\n  border-radius: 12px;\n  font-size: 14px;\n}\n\n.brand-landing-mock__engines span {\n  color: var(--bl-muted);\n  font-size: 13px;\n}\n\n.brand-landing-mock__footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-top: 14px;\n  font-size: 12.5px;\n  color: var(--bl-muted);\n}\n\n.brand-landing-mock__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 14px;\n  border-radius: 999px;\n  background: var(--bl-blue-soft);\n  color: var(--bl-blue-q);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.brand-landing-mock__btn--soft {\n  background: rgba(27, 135, 230, 0.12);\n  color: var(--bl-blue-p);\n}\n\n.brand-landing__audience h3 {\n  margin: 0 0 8px;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.brand-landing__audience p {\n  margin: 0;\n  font-size: 14.5px;\n  color: var(--bl-muted);\n}\n\n@media (max-width: 860px) {\n  .brand-landing__workflow-row,\n  .brand-landing__workflow-row--reverse {\n    grid-template-columns: 1fr;\n  }\n\n  .brand-landing__workflow-row--reverse .brand-landing__workflow-copy,\n  .brand-landing__workflow-row--reverse .brand-landing__workflow-visual {\n    order: initial;\n  }\n\n  .brand-landing__workflow-copy > p {\n    max-width: none;\n  }\n}\n\n.brand-landing__audiences {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n.brand-landing__audience {\n  border: 1px solid var(--bl-border);\n  border-radius: 14px;\n  padding: 22px;\n  background: #fff;\n}\n\n.brand-landing__faq-list {\n  max-width: 720px;\n  margin: 0 auto;\n  display: grid;\n  gap: 10px;\n}\n\n.brand-landing__faq-list details {\n  border: 1px solid var(--bl-border);\n  border-radius: 12px;\n  padding: 14px 16px;\n  background: #fff;\n}\n\n.brand-landing__faq-list summary {\n  cursor: pointer;\n  font-weight: 700;\n  font-size: 15.5px;\n  list-style: none;\n}\n\n.brand-landing__faq-list summary::-webkit-details-marker {\n  display: none;\n}\n\n.brand-landing__faq-list details p {\n  margin: 10px 0 0;\n  font-size: 14.5px;\n  color: var(--bl-muted);\n}\n\n.brand-landing__signup {\n  text-align: center;\n}\n\n.brand-landing__signup h2 {\n  margin: 0 0 12px;\n  font-size: clamp(28px, 4vw, 40px);\n  font-weight: 800;\n}\n\n.brand-landing__footer {\n  border-top: 1px solid var(--bl-border);\n  padding: 22px 0;\n  font-size: 13px;\n  color: var(--bl-muted);\n  text-align: center;\n}\n\n/* Demo */\n.brand-landing-demo {\n  border: 1px solid var(--bl-border);\n  border-radius: 16px;\n  background: #fff;\n  overflow: hidden;\n  box-shadow: 0 18px 50px rgba(27, 51, 128, 0.08);\n}\n\n.brand-landing-demo__tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--bl-border);\n  background: var(--bl-blue-soft);\n}\n\n.brand-landing-demo__tab {\n  border: 1px solid transparent;\n  background: transparent;\n  border-radius: 999px;\n  padding: 8px 14px;\n  font: inherit;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--bl-blue-q);\n  cursor: pointer;\n}\n\n.brand-landing-demo__tab.is-active {\n  background: #fff;\n  border-color: var(--bl-border);\n  color: var(--bl-blue-p);\n}\n\n.brand-landing-demo__body {\n  padding: 20px;\n}\n\n.brand-landing-demo__title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.brand-landing-demo__title-row h3 {\n  margin: 0;\n  font-size: 18px;\n}\n\n.brand-landing-demo__badge {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  background: rgba(27, 135, 230, 0.12);\n  color: var(--bl-blue-p);\n  font-size: 12px;\n  font-weight: 700;\n  padding: 4px 10px;\n}\n\n.brand-landing-demo__sov {\n  display: grid;\n  gap: 10px;\n  margin-bottom: 18px;\n}\n\n.brand-landing-demo__sov-row {\n  display: grid;\n  grid-template-columns: 140px 1fr 42px;\n  gap: 10px;\n  align-items: center;\n  font-size: 13px;\n}\n\n.brand-landing-demo__bar {\n  height: 10px;\n  border-radius: 999px;\n  background: #e8eef7;\n  overflow: hidden;\n}\n\n.brand-landing-demo__bar > span {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n}\n\n.brand-landing-demo__ranks {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  gap: 10px;\n}\n\n.brand-landing-demo__rank {\n  border: 1px solid var(--bl-border);\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.brand-landing-demo__rank strong {\n  display: block;\n  font-size: 22px;\n  margin-top: 4px;\n}\n\n.brand-landing-demo__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13.5px;\n}\n\n.brand-landing-demo__table th,\n.brand-landing-demo__table td {\n  text-align: left;\n  padding: 10px 8px;\n  border-bottom: 1px solid var(--bl-border);\n  vertical-align: top;\n}\n\n.brand-landing-demo__table th {\n  font-size: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--bl-muted);\n}\n\n.brand-landing-demo__pill {\n  display: inline-flex;\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.brand-landing-demo__pill--true {\n  background: #dff2bf;\n  color: #227700;\n}\n\n.brand-landing-demo__pill--false {\n  background: #ffbaba;\n  color: #a50000;\n}\n\n.brand-landing-demo__pill--stale {\n  background: #feefb3;\n  color: #9f6000;\n}\n\n.brand-landing-demo__pill--unverifiable {\n  background: #eee;\n  color: #555;\n}\n\n.brand-landing-demo__drift-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n  gap: 10px;\n  margin-bottom: 16px;\n}\n\n.brand-landing-demo__stat {\n  border: 1px solid var(--bl-border);\n  border-radius: 12px;\n  padding: 12px;\n}\n\n.brand-landing-demo__stat strong {\n  display: block;\n  font-size: 22px;\n  margin-top: 4px;\n}\n\n.brand-landing-demo__note {\n  margin: 0 0 14px;\n  font-size: 13.5px;\n  color: var(--bl-muted);\n}\n\n/* Form */\n.brand-landing-form {\n  max-width: 440px;\n  margin: 28px auto 0;\n  text-align: left;\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 16px;\n  padding: 22px;\n}\n\n.brand-landing-form label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  margin-bottom: 6px;\n}\n\n.brand-landing-form input {\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(255, 255, 255, 0.95);\n  color: var(--bl-blue-q);\n  border-radius: 10px;\n  padding: 11px 12px;\n  font: inherit;\n  font-size: 15px;\n  margin-bottom: 14px;\n}\n\n.brand-landing-form__hint {\n  margin: -8px 0 14px;\n  font-size: 12.5px;\n  color: rgba(255, 255, 255, 0.72);\n}\n\n.brand-landing-form__summary {\n  margin: 0 0 16px;\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.82);\n  word-break: break-word;\n}\n\n.brand-landing-form__back {\n  display: block;\n  width: 100%;\n  margin-top: 12px;\n  padding: 8px 0;\n  border: none;\n  background: transparent;\n  color: rgba(255, 255, 255, 0.78);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  text-align: center;\n}\n\n.brand-landing-form__back:hover {\n  color: #fff;\n}\n\n.brand-landing-form__error {\n  margin: 0 0 12px;\n  font-size: 13.5px;\n  color: #ffbaba;\n}\n\n.brand-landing-form .brand-landing__btn {\n  width: 100%;\n  margin-top: 4px;\n  background: rgb(var(--wu-blue-p));\n  border-color: rgb(var(--wu-blue-p));\n  color: rgb(var(--wu-gray-10));\n}\n\n.brand-landing-form .brand-landing__btn:hover {\n  background: rgb(var(--wu-blue-pHover, 84 165 236));\n  border-color: rgb(var(--wu-blue-pHover, 84 165 236));\n  color: rgb(var(--wu-gray-10));\n}\n\n.brand-landing-form__success {\n  text-align: left;\n}\n\n.brand-landing-form__success h3 {\n  margin: 0 0 8px;\n  font-size: 22px;\n}\n\n.brand-landing-form__success p {\n  margin: 0 0 16px;\n  color: rgba(255, 255, 255, 0.78);\n  font-size: 14.5px;\n}\n\n.brand-landing-form__password-box {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.18);\n  border-radius: 12px;\n  padding: 12px 14px;\n}\n\n.brand-landing-form__password-box code {\n  flex: 1;\n  min-width: 160px;\n  font-size: 15px;\n  word-break: break-all;\n}\n\n@media (max-width: 640px) {\n  .brand-landing-demo__sov-row {\n    grid-template-columns: 1fr;\n    gap: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
